// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './pharmacyFilter.scss'
import { FilterType } from './components/FilterType'
import { type PharmacyFilter } from '../../types/types'

interface Props {
  pharmacyFilters: PharmacyFilter[]
  onSelectFilter: (name: string) => void
}
export const PharmacyFilters = ({ pharmacyFilters, onSelectFilter }: Props) => (
  <div role='presentation' className='pharmacy-filter-container'>
    <div className='pharmacy-filter-row-container'>
      {pharmacyFilters.map((filter: PharmacyFilter) => (
        <FilterType
          name={filter.name}
          isSelected={filter.isActive}
          setFilter={onSelectFilter}
          key={filter.name}
          disabled={filter.disabled}
        />
      ))}
    </div>
    <div className='pharmacy-dropdown-item-separate-line' />
  </div>
)
